import React from "react";
import { Download } from "lucide-react";
import { BpLogo } from "@/components/Brand";

const ASSETS = [
  { name: "Primary logo — wordmark on navy", file: "/brand/bibleplaza-logo-master.webp", note: "WEBP · 2000×750 · owner master" },
  { name: "Lockup — app icon + wordmark", file: "/brand/bibleplaza-lockup-master.webp", note: "WEBP · 2000×760 · owner master" },
  { name: "App icon — coral", file: "/brand/bibleplaza-app-icon-master.jpg", note: "JPG · 1024×1024 · owner master" },
  { name: "Favicon", file: "/favicon.ico", note: "ICO · 16/32/48" },
  { name: "Apple touch icon", file: "/apple-touch-icon.png", note: "PNG · 180×180" },
  { name: "PWA icon 192", file: "/logo192.png", note: "PNG · 192×192" },
  { name: "PWA icon 512", file: "/logo512.png", note: "PNG · 512×512" },
];

export default function BrandDownloads() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <h1 className="font-display text-2xl font-bold tracking-tight text-[#0F3D66] sm:text-3xl">Brand &amp; downloads</h1>
      <p className="mt-1 text-sm text-[#6B6763]">
        Official BiblePlaza logo and icon files. Please use these originals untouched — do not recolor, stretch, or redraw them.
      </p>

      <div className="mt-6 rounded-3xl border border-[#E8E4DF] bg-[#1E2230] p-8">
        <BpLogo size={30} />
      </div>

      <div className="mt-6 space-y-3">
        {ASSETS.map((a) => (
          <div key={a.file} data-testid={`brand-asset-${a.file.split("/").pop()}`}
            className="flex items-center justify-between gap-3 rounded-2xl border border-[#E8E4DF] bg-white p-4">
            <div className="min-w-0">
              <div className="font-medium text-[#0F3D66]">{a.name}</div>
              <div className="text-xs text-[#6B6763]">{a.note}</div>
            </div>
            <a href={a.file} download
              className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-[#F36353] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#D94A3D]">
              <Download size={15} /> Download
            </a>
          </div>
        ))}
      </div>

      <p className="mt-6 text-xs text-[#9c9791]">© 2026 Bible Plaza LLC · hello@bibleplaza.app</p>
    </div>
  );
}
